import { Injectable } from "@angular/core";
import { SimpleLoggerService } from "@macto/ngx-simple-logger";

/**
 * Logger service does not extends BaseService in order to avoid circular dependencies.
 */
@Injectable({
    providedIn: "root"
})
export class LoggerService {
    constructor(private logger: SimpleLoggerService) {}

    public debug(msg: string, ...others: Array<any>): void {
        this.logger.debug(msg, ...others);
    }

    public warn(msg: string, ...others: Array<any>): void {
        this.logger.warn(msg, ...others);
    }

    public err(msg: string, ...others: Array<any>): void {
        this.logger.error(msg, ...others);
    }

    public info(msg: string, ...others: Array<any>): void {
        this.logger.info(msg, ...others);
    }
}
